import { useEffect, useState } from "react";
import clsx from "clsx";

import {
  tinyMceVariableInsert,
  isStringifiedJsonObject,
} from "../../helpers/text";

function MinutesRenderEngage({ meeting }) {
  const [value, setValue] = useState();
  const [iframeHeight, setIframeHeight] = useState(0);

  useEffect(() => {
    const iframe = document.getElementById("myIframe");

    const checkHeight = () => {
      const height = iframe?.contentWindow.document.body?.scrollHeight;
      if (height !== iframeHeight) {
        setIframeHeight(height);
      } else {
        clearInterval(interval);
      }
    };

    const interval = setInterval(checkHeight, 500); // Check every 500 milliseconds

    return () => clearInterval(interval);
  }, [value, iframeHeight]);

  useEffect(() => {
    try {
      if (meeting) {
        if (meeting?.pdfMinutes.motionHeadingTitle.length > 0) {
          if (isStringifiedJsonObject(meeting?.pdfMinutes.motionHeadingTitle)) {
            const variablesInserted = tinyMceVariableInsert(
              JSON.parse(meeting.pdfMinutes.motionHeadingTitle),
              {
                boardName: meeting.department?.name,
                address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
                startTime: meeting.startTime,
                endTime: meeting.endTime,
                attendance: meeting.localAttended,
                dateTime: meeting.scheduleDate,
                date: meeting.scheduleDate?.replace(/(,\s\d{4}).*/, "$1"),
              }
            );
            setValue(`<!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Document</title>
              <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
              <!-- Include any other styles specific to your content -->
            </head>
            <body>
              ${variablesInserted}
            </body>
            </html>`);
            // setValue(`${variablesInserted}`);
          } else {
            let templateString = `
            <p style="text-align: center; line-height: 1;"><strong><span style="color: rgb(0, 0, 0);">Minutes for the {{boardName}}</span></strong></p>
            <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{address}}</span></p>
            <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{startTime}} - {{endTime}}</span></p>
            <p style="line-height: 1; text-align: left;">&nbsp;</p>
            <p style="line-height: 1; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>Roll Call:</strong> <em>(The following members were in attendance)</em></span></p>
            <ul>
             {{attendance}}
            </ul>
              `;
            const templateInserted = tinyMceVariableInsert(templateString, {
              boardName: meeting.department?.name,
              address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
              startTime: meeting.startTime,
              endTime: meeting.endTime,
              attendance: meeting.localAttended,
              dateTime: meeting.scheduleDate,
              date: meeting.scheduleDate?.replace(/(,\s\d{4}).*/, "$1"),
            });
            // setValue(`${templateInserted}`);
            setValue(`<!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Document</title>
              <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
              <!-- Include any other styles specific to your content -->
            </head>
            <body>
              ${templateInserted}
            </body>
            </html>`);
          }
        } else {
          let templateString = `
          <p style="text-align: center; line-height: 1;"><strong><span style="color: rgb(0, 0, 0);">Minutes for the {{boardName}}</span></strong></p>
          <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{address}}</span></p>
          <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{startTime}} - {{endTime}}</span></p>
          <p style="line-height: 1; text-align: left;">&nbsp;</p>
          <p style="line-height: 1; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>Roll Call:</strong> <em>(The following members were in attendance)</em></span></p>
          <ul>
           {{attendance}}
          </ul>
            `;
          const templateInserted = tinyMceVariableInsert(templateString, {
            boardName: meeting.department?.name,
            address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
            startTime: meeting.startTime,
            endTime: meeting.endTime,
            attendance: meeting.localAttended,
            dateTime: meeting.scheduleDate,
            date: meeting.scheduleDate?.replace(/(,\s\d{4}).*/, "$1"),
          });
          // setValue(`${templateInserted}`);
          setValue(`<!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Document</title>
              <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
              <!-- Include any other styles specific to your content -->
            </head>
            <body>
              ${templateInserted}
            </body>
            </html>`);
        }
      }
    } catch (error) {
      console.error(error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  return (
    <div
      className={clsx("w-full")}
      style={{ height: `${iframeHeight + 34}px` }}
    >
      {value && (
        <iframe
          id="myIframe"
          srcDoc={value}
          style={{ width: "100%", height: "100%", border: "none" }}
          sandbox="allow-same-origin"
        ></iframe>
      )}
    </div>
  );
}

export default MinutesRenderEngage;
